export class Update {
    constructor(
        public label: string
    ) { }
}
